export default __webpack_public_path__ + "static/media/volume-high.7ba5c4d3.svg";